import { connect, createStore, updateStore } from '../lib/store';
import { camelToKebabCase, randomStr } from '../lib/utils';
const themeStoreMap = new WeakMap();
export function getThemeStore(theme) {
    return themeStoreMap.get(theme);
}
const themePropMap = new WeakMap();
export function getThemeProp(theme) {
    return themePropMap.get(theme);
}
function replaceStyle(style, theme) {
    const themeStore = themeStoreMap.get(theme);
    const themeProp = themePropMap.get(theme);
    const rules = Object.keys(themeStore).reduce((prev, key) => {
        if (!themeStore[key])
            return prev;
        return prev + `${themeProp[key]}:${themeStore[key]};`;
    }, '');
    style.textContent = `:root, :host {${rules}}`;
}
/**
 * 创建主题，插入 `document.head`
 * https://github.com/mantou132/gem/issues/33
 *
 * @example
 * createTheme({
 *   primaryColor: '#eee',
 * });
 */
export function createTheme(themeObj) {
    const salt = randomStr();
    const style = document.createElement('style');
    const themeStore = createStore(themeObj);
    const theme = {};
    const themeProp = {};
    themePropMap.set(theme, themeProp);
    themeStoreMap.set(theme, themeStore);
    Object.keys(themeStore).forEach((key) => {
        themeProp[key] = `--${camelToKebabCase(key)}-${salt}`;
        theme[key] = `var(${themeProp[key]})`;
    });
    const replace = () => replaceStyle(style, theme);
    connect(themeStore, replace);
    replace();
    (document.head || document.documentElement).append(style);
    return theme;
}
/**
 * 更新主题
 * @param theme 主题
 * @param newThemeObj 新主题
 */
export function updateTheme(theme, newThemeObj) {
    const store = getThemeStore(theme);
    updateStore(store, newThemeObj);
}
//# sourceMappingURL=theme.js.map